<template>
    <div>
        <span v-if="label" :class="['form-label']">{{ label }}:</span>
        <template v-for="(entry, idx) in entries">
            <div class="lg:flex md:items-center">
                <input :id="id + '-' + idx" ref="input" v-bind="$attrs" :class="{ error: error }" class="mb-2" type="checkbox"
                       v-model="model" :value="entry.value"/>
                <label v-if="entry.label" class="form-label lg:text-left lg:pl-2"
                       :for="id + '-' + idx">{{ entry.label }}</label>
                <div v-if="error" class="form-error">{{ error }}</div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        entries: Array,
        label: String,
        id: {
            type: String,
            default() {
                return `checkbox-group-${this._uid}`
            },
        },
        error: String,
        inline: {
            type: Boolean,
            default() {
                return false;
            }
        },
        value: Array,
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("input", newValue);
            },
        },
    }
}
</script>
